import { EmpathizeState } from '../../models';

export function getInitialEmpathizeState(): EmpathizeState {
  return {
    identifierSuggestions: [],
    loading: false,
    popularSearches: [],
    resultsSuggestions: [],
    selectedEmpathizeBlock: { x: 0, y: 0 },
    selectedIndex: -1,
    termSuggestions: []
  };
}
